import React from 'react';

const Analytics = () => {
  return (
    <div style={{ padding: '20px' }}>
      {/* <h2></h2> */}
      <iframe
        title="Analytics Dashboard"
        width="100%"
        height="600"
        style={{ border: '1px solid #ccc', borderRadius: '8px' }}
        src="https://lookerstudio.google.com/embed/reporting/f6e78970-33b6-41e4-b4a6-5d9dcb0c1503/page/kIV1C"
        allowFullScreen
      ></iframe>
    </div>
  );
};
export default Analytics;